import type { JSX } from 'react';

import { InvitationResultDialog } from '@/components/InvitationResultDialog';

import { invitationLink, type PlatformAdminInvitation } from '../api/platform-admins.graphql';

interface Props {
  invitation: PlatformAdminInvitation;
  onClose: () => void;
}

/**
 * OS-1717 — resultado de invitar o renovar la invitación de un administrador de plataforma. El
 * diálogo es el mismo que el del administrador inicial del tenant (OS-1719).
 */
export function InvitationLinkDialog({ invitation, onClose }: Props): JSX.Element {
  const token = invitation.invitationToken;
  return (
    <InvitationResultDialog
      email={invitation.admin.email}
      delivery={invitation.emailDelivery}
      link={token ? invitationLink(token) : null}
      expiresAt={invitation.invitationExpiresAt}
      resendAction="Renovar invitación"
      onClose={onClose}
    />
  );
}
